import React from "react"
import PubNub from "pubnub"
import { MessageChanelList, SendMessage } from "../../components/ChatComponent"
import { Helmet } from "react-helmet"
import { Card } from "../../components/Card"
import { ButtonLoader } from "../../components/Button"
import { ActionsButtons } from "../../components/ActionsButtons"
import TagContainer from "../../container/TagContainer"
import { CheckBox, Label, SelectInput } from "../../components/Form"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../../components/Modal"
import { platformDetails } from "../../core/utils/platformDetails"

const FilterModal = ({
  tagsOptions,
  modalIsOpen,
  setModalIsOpen,
  onChangeFilterTags,
  values,
  hasButtons = true,
  channelLoading,
  loadTags,
  handleTagsToFilter,
  tagsToFilter,
}) => {
  return (
    <ModalPanel modalIsOpen={modalIsOpen} width={400}>
      <ModalHeader closeModal={() => setModalIsOpen(false)} title="Filtro"/>
      <ModalBody className="filter-modal-chat-input">
        <>
          <div className="toggle-label-tags">
            <Label label="Tags" />
            {values?.tag && values.tagException && (
              <CheckBox
                className="check-date"
                label="Ao menos uma tag"
                onChange={handleTagsToFilter}
                value="tagsToFilter"
                checked={tagsToFilter}
              />
            )}
          </div>
          <SelectInput
            onChange={onChangeFilterTags("tag")}
            closeMenuOnSelect={false}
            placeholder="Selecione uma tag"
            isSearchable={true}
            isClearable={true}
            name="tag"
            options={tagsOptions}
            value={values.tag || ""}
            defaultValue={values.tag || ""}
            isOverModal={true}
          />

          <Label label="Selecionar produtores sem a(s) tag(s):" />
          <SelectInput
            onChange={onChangeFilterTags("tagException")}
            closeMenuOnSelect={false}
            placeholder="Selecione uma tag"
            isSearchable={true}
            isClearable={true}
            name="tagException"
            options={tagsOptions.filter((item) => item?.label !== values?.tag?.label)}
            value={values.tagException || ""}
            defaultValue={values.tagException || ""}
            isOverModal={true}
          />
        </>
      </ModalBody>
      {hasButtons && (
        <ModalFooter>
          <ButtonLoader
            className="button-engagement"
            label="Confirmar"
            handleClick={loadTags}
            messageProcess="Buscando..."
            loading={channelLoading}
            color="orange"
          />
        </ModalFooter>
      )}
    </ModalPanel>
  )
}

function ChatScreen({
  loggedUser,
  chat,
  setChat,
  tab,
  tabOptions,
  onSendMessages,
  onKeyPress,
  channels,
  messages,
  onChange,
  onChangeFilterTags,
  values,
  loading,
  channelLoading,
  setOpenPicker,
  openPicker,
  onDeleteMessage,
  uploadFiles,
  newChat,
  unreadMessage,
  onTab,
  createdAt,
  setRead,
  read,
  modalFilterIsOpen,
  setModalFilterIsOpen,
  tags,
  selectedTag,
  selectedTagSecondFilter,
  loadTags,
  tagsToFilter,
  handleTagsToFilter,
  onQuickFilterClick,
  isQuickFilterActive,
}) {
  const { platformName } = platformDetails()

  return (
    <div className="div-container">
      <Helmet>
        {unreadMessage === 0 || unreadMessage === "" ? (
          <title>{platformName}</title>
        ) : (
          <title>{`(${unreadMessage}) ${platformName}`}</title>
        )}
      </Helmet>
      <Card className="chat-row">
        <MessageChanelList
          selectedChat={chat}
          onSelectChat={(item) => setChat(item)}
          onTab={(tab) => onTab(tab)}
          tab={tab}
          tabOptions={tabOptions}
          channels={channels}
          onChange={(event) => onChange("search", { value: event.target.value })}
          loading={channelLoading}
          setRead={setRead}
          read={read}
          handleClick={() => setModalFilterIsOpen(true)}
          values={values}
          onQuickFilterClick={onQuickFilterClick}
          isQuickFilterActive={isQuickFilterActive}
        />
        <div className="chat-collumn">
          <SendMessage
            chat={chat}
            theme={theme}
            pubnub={pubnubData}
            currentChannel={currentChannel}
            selectedChat={chat}
            onSend={onSendMessages}
            onKeyPress={onKeyPress}
            messages={messages}
            loggedUser={loggedUser}
            onChangeMessage={(value) => onChange("message", value)}
            onSendFile={(file) => uploadFiles(file)}
            valueMessage={values && values.message ? values.message : ""}
            onChangeVoic={(value, file) => onChange("audio", { value, file })}
            valueVoic={values && values.audio && values.audio.value}
            loading={loading}
            setOpenPicker={setOpenPicker}
            openPicker={openPicker}
            onDeleteMessage={(item) => onDeleteMessage(item)}
            newChat={newChat}
            createdAt={createdAt}
            rightHeader={
              <div className="actions-button-chat buttons">
                {!chat ||
                chat.length === 0 ||
                chat.users.length > 2 ||
                !chat?.usersGroup?.length ? (
                  <></>
                ) : (
                  <>
                    <ActionsButtons {...{ selectedsUsers: chat?.notLoggedUser, isChatContainer: true }} />
                    <TagContainer users={chat?.notLoggedUser} isChatContainer={true} />
                  </>
                )}
              </div>
            }
          />
        </div>
      </Card>

      <FilterModal
        {...{
          modalIsOpen: modalFilterIsOpen,
          setModalIsOpen: setModalFilterIsOpen,
          tagsOptions: tags,
          onChangeFilterTags,
          selectedTag,
          selectedTagSecondFilter,
          values,
          channelLoading,
          loadTags,
          handleTagsToFilter,
          tagsToFilter,
        }}
      />
    </div>
  )
}

export default ChatScreen
const currentChannel = "Default"
const theme = "light"
const pubnubData = new PubNub({
  publishKey: "pub-c-522c83d7-f96e-44fd-8152-e19184ca296a",
  subscribeKey: "sub-c-02d0ce14-bf0b-11ec-bd2a-8ab19e3fdcf0",
  uuid: "sec-c-MWQ2NjMwMjgtN2I2Zi00ZWFkLTkzNTgtMGZiMjkyZjEyMjcw",
})
